import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  id: "header",
  class: "bg-white py-3 shadow-sm border-b border-gray-200 mx-auto"
}
const _hoisted_2 = { class: "ml-20 px-0 flex justify-between" }
const _hoisted_3 = { class: "md:flex space-x-6 items-center mr-20" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center space-x-2"
}
const _hoisted_5 = {
  key: 0,
  class: "text-gray-400 text-sm"
}
const _hoisted_6 = {
  key: 1,
  class: "text-sm font-semibold text-gray-700"
}
const _hoisted_7 = {
  key: 1,
  class: "flex items-center ml-6"
}
const _hoisted_8 = { class: "text-gray-700 text-sm" }

import { onMounted, computed } from 'vue';
import { useAuthStore } from '@/store/auth';
import { useBillingStore } from '@/store/billing';


export default /*@__PURE__*/_defineComponent({
  __name: 'header',
  setup(__props) {

const authStore = useAuthStore();
const billingStore = useBillingStore();

const isPublic = computed(() => localStorage.getItem('purpose') === 'public');

onMounted(() => {
  if (isPublic.value) {
    billingStore.fetchPublicBalance();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex items-center" }, [
        _createElementVNode("h3", { class: "bg-brand text-2xl text-center text-green-800" }, [
          _createElementVNode("i", { class: "fa-solid fa-fingerprint text-green-800 font-bold" }),
          _createTextVNode(" ether"),
          _createElementVNode("span", { class: "font-bold" }, ".id")
        ])
      ], -1)),
      _createElementVNode("nav", _hoisted_3, [
        (isPublic.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fa-solid fa-wallet text-green-600 text-sm" }, null, -1)),
              (_unref(billingStore).balanceLoading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Loading..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, " UGX " + _toDisplayString(_unref(billingStore).balance !== null ? Number(_unref(billingStore).balance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '—'), 1))
            ]))
          : _createCommentVNode("", true),
        (_unref(authStore).user && _unref(authStore).user.firstName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(authStore).user.firstName) + " " + _toDisplayString(_unref(authStore).user.lastName), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "md:hidden" }, [
        _createElementVNode("button", {
          class: "text-gray-700",
          type: "button"
        }, [
          _createElementVNode("i", { class: "fa-solid fa-bars" })
        ])
      ], -1))
    ])
  ]))
}
}

})